import styled from 'react-emotion'
import { Label } from 'shared/ui'
import vars from 'ui_theme/site/globals/site.variables'

export const Row = styled('div')`
  margin-bottom: ${vars.mini};
`

export const Key = styled('span')`
  font-weight: 500;
`

export const TopSection = styled('div')``

export const Section = styled('div')`
  padding: 24px;
  padding-top: 16px;
  padding-bottom: 16px;
  border-bottom: 1px solid #e4e8ed;

  &:last-child {
    border: 0;
  }
`

export const SectionLabel = styled(Label)`
  margin-bottom: 10px;
`
